import React from 'react'
import { Pane,Tab,Tablist} from 'evergreen-ui';
import ProfileTab from '../tab/profile';
import AdminTab from '../tab/admin';
// import NotificationTab from '../tab/notification';
import SupportTab from '../tab/support';
import Cookies from 'js-cookie';

function SettingsTabWidget() {
    const [selectedIndex, setSelectedIndex] = React.useState(0)
const managerType = Cookies.get('managerType');

    const [tabs] = React.useState(managerType ==='sub'
    ? [
       'Profile',
        // 'Admin', 
        "Support/Help" 
    ]
    : [
        'Profile',
        'Admin', 
        // 'Notification',
        "Support/Help"
])
    const tabsTab = managerType ==='sub'
    ? [
        <ProfileTab/>, 
        <SupportTab/>
    ]
    :[
        <ProfileTab/>, 
        <AdminTab/>, 
        // <NotificationTab/>,
        <SupportTab/>
    ]
  
  return (
    <div>
    <div height={120}>
        <Pane background="tint1" padding={16}>
        <Tablist marginBottom={16} flexBasis={240} marginRight={24}>
            {tabs.map((tab, index) => (
            <Tab
                aria-controls={`panel-${tab}`}
                isSelected={index === selectedIndex}
                key={tab}
                onSelect={() => setSelectedIndex(index)}
            >
                {tab}
            </Tab>
            ))}
        </Tablist>
        </Pane>
        <br/><br/>
        <div padding={16} background="tint1" flex="1">
            {tabsTab[selectedIndex]}
        </div>
    </div>
    </div>
  )
}

export default SettingsTabWidget